import { memo } from "react";
import PropTypes from "prop-types";
import "./ReasonToBook.scss";
import { messagePropType } from "app/utils/propTypes";
import CustomFormattedMessageContainer from "app/pages/.shared/CustomFormattedMessage/CustomFormattedMessageContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ReasonToBook = ({ title, description, picto }) => {
	return (
		<div className="reason-to-book">
			{picto && (
				<div className="reason-to-book__picto">
					<i
						style={{
							maskImage: `url(${picto})`,
							WebkitMaskImage: `url(${picto})`,
						}}
					/>
				</div>
			)}
			<div>
				{title && (
					<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
						<CustomFormattedMessageContainer
							message={title}
							className="reason-to-book__title"
							enableHTMLFormatting={true}
						/>
					</Typography>
				)}
				{description && (
					<CustomFormattedMessageContainer
						message={description[0]}
						className="reason-to-book__description"
						enableHTMLFormatting={true}
					/>
				)}
			</div>
		</div>
	);
};

ReasonToBook.propTypes = {
	title: messagePropType,
	description: messagePropType,
	picto: PropTypes.string,
};

export default memo(ReasonToBook);
